import { textSmSemibold } from '@insify/design-system/typography';

import styles from './BetaRibbon.module.css';

export const BetaRibbon = () => {
  return (
    <div className={styles.ribbon}>
      <span className={textSmSemibold}>BETA</span>
    </div>
  );
};
